$(function() {
  
  function renderCartNotificationProduct(key, title, image, variantTitle) {
  	return `<div id="shopify-section-cart-notification-product" class="shopify-section">
		<div id="cart-notification-product-${key}" class="cart-item">
          <div class="cart-notification-product__image global-media-settings">
			<img src="${image}" alt="Hard Rock" width="70" height="70" loading="lazy"> </div>
          <div>
            <h3 class="cart-notification-product__name h4">${title}</h3>
			${variantTitle ? `<dl>
              <div class="product-option">
                  <!--<dt>Nicotine Strength: </dt>-->
				  <dd>${variantTitle}</dd>              
              </div>
              </dl>`: ``
            }
          </div> 
       </div>
    </div>`
  }
  
  function renderCartBubble(cartItemCount) {
  	return `<div id="shopify-section-cart-icon-bubble" class="shopify-section">
       <svg id="Icon_feather-shopping-cart" data-name="Icon feather-shopping-cart" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42"> <g id="Group_148482" data-name="Group 148482" transform="translate(-1325 -45)"> <circle id="Ellipse_517" data-name="Ellipse 517" cx="21" cy="21" r="21" transform="translate(1325 45)" fill="#ffdf91"/> <path id="Path_1" data-name="Path 1" d="M3.468,5.087V2.051A1.552,1.552,0,0,1,5.019.5H9.943a1.552,1.552,0,0,1,1.551,1.551V5.9A1.552,1.552,0,0,1,9.943,7.448H2.051A1.551,1.551,0,0,0,.5,9v7.824a1.552,1.552,0,0,0,1.551,1.551H12.709a1.552,1.552,0,0,0,1.551-1.551V7.448" transform="translate(1338.599 56.238)" fill="none" stroke="#1c1c1a" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.2"/> </g> </svg>
		<div class="cart-count-bubble"><span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden"> items</span>\n  </div>
    </div>
	`
  }
  
  function getCart(callback) {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json', 
      success: function (data) {
      	callback(data)
      }
    });
  }
  
  $('.cart_btn').on('click', function(e){
    e.preventDefault();
    var cartNotification = new CartNotification();
    cartNotification.setActiveElement(document.activeElement)
    console.log("Add to cart")
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        items: [{
          quantity: parseInt($(this).parents(".card-information").find('.quantity__input').val()),
        //id: parseInt($(this).parents('.card-information').find('.product-form__input input[type=radio]:checked').attr('data-variant'))
          id: parseInt($(this).parents('.card-information').find('.product-form__input select option:selected').attr('data-variant'))
        }]
      },
      dataType: 'json', 
      success: function (data) {
        console.log('data', data.items[0].options_with_values)
        
        var items = data.items;
        if (items.length) {
          var key = items[0].key
          var image = items[0].image
          var title = items[0].product_title
          var variantTitle = items[0].variant_title
          
          getCart((cartData)=>{
            cartNotification.renderContents({
              ...items[0],
              key: key,
              sections: {
                  "cart-notification-product": renderCartNotificationProduct(key, title, image, variantTitle),
                  "cart-notification-button": `<div id="shopify-section-cart-notification-button" class="shopify-section">View Cart (${cartData.item_count})</div>`,
                  "cart-icon-bubble": renderCartBubble(cartData.item_count)
              }
            })
          })
        }
      } 
    });
  })
})
